import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgSpironolactoneGlyph from './svgs/SpironolactoneGlyph.js';
import { useIcon } from '../../shared-components/icon/index.js';

var spironolactoneGlyph = (props => useIcon(SvgSpironolactoneGlyph, null, props));

export { spironolactoneGlyph as default };
